import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SelectOption } from '../types';
import { OptionOrientation } from '../../../Shared/Enums/optionOrientation';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

interface RadioButtonsProps {
  label: string;
  selectedValue: string;
  inputOptions: SelectOption[];
  saveSingleSelection: (value: string) => void;
  renderValidationErrors: () => boolean | JSX.Element;
  selectedOptionOrientation: OptionOrientation;
  isHorizontalFourthOrThird: boolean;
}

export default (props: RadioButtonsProps) => {
  const {
    label,
    selectedValue,
    inputOptions,
    saveSingleSelection,
    renderValidationErrors,
    selectedOptionOrientation,
    isHorizontalFourthOrThird
  } = props;

  const isHorizontal =
    selectedOptionOrientation == OptionOrientation.HORIZONTAL;

  const handleRadioOnClick = (rbValue: string) => {
    if (rbValue === selectedValue) {
      saveSingleSelection('');
    } else {
      saveSingleSelection(rbValue);
    }
  };
  return (
    <>
      <FormLabel>{label}</FormLabel>
      <RadioGroup name="radioGroupSelector" value={selectedValue}>
        <Grid container direction={isHorizontal ? 'row' : 'column'}>
          {inputOptions.map((option) => {
            return (
              <>
                <Grid
                  item
                  width={
                    isHorizontal
                      ? isHorizontalFourthOrThird
                        ? '7.188rem'
                        : '11.875rem'
                      : undefined
                  }
                >
                  <FormControlLabel
                    key={option.id}
                    value={option.value}
                    label={<Typography>{option.value}</Typography>}
                    control={
                      <Radio
                        name={option.value}
                        onClick={(event) => {
                          event.preventDefault();
                          handleRadioOnClick(option.value);
                        }}
                      />
                    }
                  />
                </Grid>
              </>
            );
          })}
        </Grid>
      </RadioGroup>

      {renderValidationErrors()}
    </>
  );
};
